import React, { FC, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownload } from '@fortawesome/pro-light-svg-icons';
import { Button } from 'src/common';
import { downloadFile } from 'src/helpers/files';

interface IProps {
  getUrl?: string;
  name: string;
}

export const DocumentsDownload: FC<IProps> = props => {
  const { getUrl: url, name } = props;

  const onDownload = useCallback(() => {
    if (!!url) {
      downloadFile(url, name);
    }
  }, [url, name]);
  return <Button type={'text'} onClick={onDownload} icon={<FontAwesomeIcon icon={faCloudDownload} />} />;
};

export default DocumentsDownload;
